import React from 'react';
import { Button, Headline, Logo, Paragraph } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';
import { updateItemInStorage } from '../../util/sessionStorage';

const StyledContainer = styled.div`
  padding-top: 64px;
  max-width: 875px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

interface ErrorPageProps {
  title: string;
  message?: string | React.ReactElement;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ title, message }: ErrorPageProps) => {
  return (
    <StyledContainer>
      <Logo dataQaId='logo' />
      <Headline data-qa-id='error-headline'>{title}</Headline>
      <Paragraph data-qa-id='error-description'>{message || ''}</Paragraph>
      <div style={{ alignSelf: 'flex-end' }}>
        <Button
          qaId='back-btn'
          onClick={() => {
            updateItemInStorage('centre', null);
            updateItemInStorage('businessUnit', null);
            updateItemInStorage('moderatorSeries', null);
            updateItemInStorage(`oidc.user:${window.env.SAP_CDC_DOMAIN}:${window.env.SAP_CDC_CLIENT_ID}`, null);
            window.location.href = `${window.env.SAP_CDC_LOGOUT}?redirect_uri=${window.location.origin}`;
          }}
          size='medium'
        >
          Back to login
        </Button>
      </div>
    </StyledContainer>
  );
};
